<template>

  <div class="container">
    <h1 class="mt-2">{{ $t("Inici") }}</h1>

    <section class="content-hotnews" style="outline-style: none;">

      <div class="grid-container esquerra" style="outline-style: none;">

        <div class="area-gran">
          <div class="card rounded-0 border-0 bg-transparent"  >

            <picture>
              <source media="(max-width: 600px)" srcset="https://www.upc.edu/ca/sala-de-premsa/noticies/primera-vegada-audiodescripcio-produccio-audiovisual/@@images/imatge/mobile">
              <img class="card-img-top rounded-0" src="../assets/images/home/apren-publicar2.jpg" alt="Una imatge del vídeo, en què es veu una estudiant en bicicleta davant d'un camp" width="1280" height="720">
            </picture>
            <div class="card-body">
              <router-link :to="{name: 'publish'}" class="stretched-link">
                <h2 class="card-title mt-4">{{ $t("Com publicar a Aprèn") }}</h2>
                <p>{{ $t("Per tal que un contingut docent aparegui publicat al portal Aprèn, cal que abans hagi estat dipositat a UPCommons, a Zonavídeo si es tracta d'un audiovisual o mitjançant Atenea, l'entorn virtual d'aprenentatge de la UPC.") }}</p>
                <p>{{ $t("El professorat de la UPC pot publicar continguts docents a UPCommons adreçant-se a la seva biblioteca, o mitjançant Atenea, l'entorn virtual d'aprenentatge de la UPC.") }}</p>
              </router-link>
            </div>
          </div>
        </div>




        <div class="area1">
          <div class="card rounded-0 border-0 bg-transparent">

            <picture>
              <source media="(max-width: 992px and min-width: 600px)" srcset="https://www.upc.edu/idp/ca">
              <img loading="lazy" src="../assets/images/home/home-idp.png" alt="Publicacions: Iniciativa Digital Politècnica (IDP)" width="700" height="450">
            </picture>
            <div class="card-body">
              <a class="stretched-link" href="https://www.upc.edu/idp/ca" target="_blank">
                <h3 class="card-title">{{ $t("Publicacions: Iniciativa Digital Politècnica (IDP)") }}</h3>
                <p>{{ $t("Oficina de Publicacions Acadèmiques Digitals de la UPC. Suport a la creació de continguts digitals per a la docència i la recerca.") }}</p>
              </a>
            </div>
          </div>
        </div>



        <div class="area2">
          <div class="card rounded-0 border-0 bg-transparent">

            <picture>
              <source media="(max-width: 992px and min-width: 600px)" srcset="https://serveistic.upc.edu/ca/produccio-audiovisual">
              <img loading="lazy" src="../assets/images/home/home-zonavideo.png" alt="Audiovisuals i Zonavídeo" width="700" height="526">
            </picture>
            <div class="card-body">
              <a class="stretched-link" href="https://serveistic.upc.edu/ca/produccio-audiovisual" target="_blank">
                <h3 class="card-title">{{ $t("Audiovisuals i Zonavídeo") }}</h3>
                <p>{{ $t("Servei de suport a la producció audiovisual. Zonavídeo UPC és la plataforma de la UPC per a la publicació de vídeos a Internet.") }}</p>
              </a>
            </div>
          </div>
        </div>



        <div class="area3">
          <div class="card rounded-0 border-0 bg-transparent">
            <picture>
              <source media="(max-width: 992px and min-width: 600px)" srcset="https://bibliotecnica.upc.edu/professors">
              <img loading="lazy" src="../assets/images/home/home-einespdi.png" alt="Eines pel PDI" width="700" height="526">
            </picture>

            <div class="card-body">
              <a class="stretched-link" href="https://bibliotecnica.upc.edu/professors" target="_blank">
                <h3 class="card-title">{{ $t("Eines pel PDI") }}</h3>
                <p>{{ $t("Eines i recursos per a la gestió de la docència i la gestió, orientació i assesorament al campus virtual, elaboració de materials, drets d'autor, préstec, publicació, etc.") }}</p>
              </a>
            </div>
          </div>
        </div>



        <div class="area4" style="outline-style: none;">
          <div class="card rounded-0 border-0 bg-transparent" style="outline-style: none;">

            <picture>
              <source media="(max-width: 992px and min-width: 600px)" srcset="https://www.upc.edu/slt/ca">
              <img loading="lazy" src="../assets/images/home/home-slt.jpg" alt="Servei de Llengües i Terminologia (SLT)" width="301" height="400">
            </picture>
            <div class="card-body" style="outline-style: none;">
              <a class="stretched-link" href="https://www.upc.edu/slt/ca" target="_blank" style="outline-style: none;">
                <h3 class="card-title">{{ $t("Servei de Llengües i Terminologia (SLT)") }}</h3>
                <p>{{ $t("Serveis i recursos lingüístics de la UPC.") }}</p>
              </a>
            </div>
          </div>
        </div>

      </div>

    </section>


    <h2 class="mt-5">Aprèn {{ $t("avui") }}</h2>
    <div class="well">
      <ul class="list-numeral" v-if="dataHeader">
        <li class="violeta-fosc"><strong>{{ dataHeader.num_professor }}</strong>{{ $t('Professorat') }}</li>
        <li class="violeta-intens"><strong>{{ dataHeader.num_organitzacio }}</strong>{{ $t('Organització') }}</li>
        <li class="rosa-intens"><strong>{{ dataHeader.num_assignatura }}</strong>{{ $t('Assignatures') }}</li>
        <li class="vermell-intens"><strong>{{ dataHeader.num_titulacio }}</strong>{{ $t('Titulacions') }}</li>
        <li class="taronja-intens"><strong>{{ totalActivitats }}</strong>{{ $t('Activitats') }}</li>
      </ul>
      <ul class="list-numeral" v-if="dataHeader">
        <li class="violeta-fosc"><strong>{{ formatNumber(dataHeader.num_material) }}</strong>{{ $t('Materials') }}</li>
        <li class="violeta-intens"><strong>{{ dataHeader.num_openAccess }}</strong>{{ $t('Accés Obert') }}</li>
        <li class="rosa-intens"><strong>{{ dataHeader.num_pfc }}</strong>{{ $t('Treballs Finals') }}</li>
        <li class="vermell-intens"><strong>{{ dataHeader.num_video }}</strong>{{ $t('Vídeos') }}</li>
        <li class="groc-intens"><strong>{{ dataHeader.num_innovacio }}</strong>{{ $t('Innovacio') }}</li>
      </ul>
    </div>

    <WeeklySummaryCard />




    <!--div class="home-block-sdg">
      <h2 class="mt-5">{{ $t('material_ods') }}</h2>
      <div class="d-flex flex-wrap align-items-stretch justify-content-center">
        <div class="sdg">
          <router-link-locale :to="{name: 'materials', params: {page: 1, sort: 'data desc, activitat_data_available desc'}, query: {material_ods: '01 - Fi de la Pobresa'}}" title="1. Fi de la pobresa">
            <img src="../assets/images/sdg/1.png" alt="01 - Fi de la Pobresa">
          </router-link-locale>
        </div>
        <div class="sdg">
          <router-link-locale :to="{name: 'materials', params: {page: 1, sort: 'data desc, activitat_data_available desc'}, query: {material_ods: '02 - Fam zero'}}" title="1. Fi de la pobresa">
            <img src="../assets/images/sdg/2.png" alt="02 - Fam zero">
          </router-link-locale>
        </div>
        <div class="sdg">
          <router-link-locale :to="{name: 'materials', params: {page: 1, sort: 'data desc, activitat_data_available desc'}, query: {material_ods: '03 - Salut i Benestar'}}" title="1. Fi de la pobresa">
            <img src="../assets/images/sdg/3.png" alt="03 - Salut i Benestar">
          </router-link-locale>
        </div>
        <div class="sdg">
          <router-link-locale :to="{name: 'materials', params: {page: 1, sort: 'data desc, activitat_data_available desc'}, query: {material_ods: '04 - Educació de Qualitat'}}" title="1. Fi de la pobresa">
            <img src="../assets/images/sdg/4.png" alt="04 - Educació de Qualitat">
          </router-link-locale>
        </div>
        <div class="sdg">
          <router-link-locale :to="{name: 'materials', params: {page: 1, sort: 'data desc, activitat_data_available desc'}, query: {material_ods: '05 - Igualtat de Gènere'}}" title="1. Fi de la pobresa">
            <img src="../assets/images/sdg/5.png" alt="05 - Igualtat de Gènere">
          </router-link-locale>
        </div>
        <div class="sdg">
          <router-link-locale :to="{name: 'materials', params: {page: 1, sort: 'data desc, activitat_data_available desc'}, query: {material_ods: '06 - Aigua Neta i Sanejament'}}" title="1. Fi de la pobresa">
            <img src="../assets/images/sdg/6.png" alt="06 - Aigua Neta i Sanejament">
          </router-link-locale>
        </div>
        <div class="sdg">
          <router-link-locale :to="{name: 'materials', params: {page: 1, sort: 'data desc, activitat_data_available desc'}, query: {material_ods: '07 - Energia Assequible i No Contaminant'}}" title="1. Fi de la pobresa">
            <img src="../assets/images/sdg/7.png" alt="07 - Energia Assequible i No Contaminant">
          </router-link-locale>
        </div>
        <div class="sdg">
          <router-link-locale :to="{name: 'materials', params: {page: 1, sort: 'data desc, activitat_data_available desc'}, query: {material_ods: '08 - Treball Decent i Creixement Econòmic'}}" title="1. Fi de la pobresa">
            <img src="../assets/images/sdg/8.png" alt="08 - Treball Decent i Creixement Econòmic">
          </router-link-locale>
        </div>
        <div class="sdg">
          <router-link-locale :to="{name: 'materials', params: {page: 1, sort: 'data desc, activitat_data_available desc'}, query: {material_ods: '09 - Indústria, Innovació i Infraestructura'}}" title="1. Fi de la pobresa">
            <img src="../assets/images/sdg/9.png" alt="09 - Indústria, Innovació i Infraestructura">
          </router-link-locale>
        </div>
        <div class="sdg">
          <router-link-locale :to="{name: 'materials', params: {page: 1, sort: 'data desc, activitat_data_available desc'}, query: {material_ods: '10 - Reducció de les Desigualtats'}}" title="1. Fi de la pobresa">
            <img src="../assets/images/sdg/10.png" alt="10 - Reducció de les Desigualtats">
          </router-link-locale>
        </div>
        <div class="sdg">
          <router-link-locale :to="{name: 'materials', params: {page: 1, sort: 'data desc, activitat_data_available desc'}, query: {material_ods: '11 - Ciutats i Comunitats Sostenibles'}}" title="1. Fi de la pobresa">
            <img src="../assets/images/sdg/11.png" alt="11 - Ciutats i Comunitats Sostenibles">
          </router-link-locale>
        </div>
        <div class="sdg">
          <router-link-locale :to="{name: 'materials', params: {page: 1, sort: 'data desc, activitat_data_available desc'}, query: {material_ods: '12 - Producció i Consum Responsables'}}" title="1. Fi de la pobresa">
            <img src="../assets/images/sdg/12.png" alt="12 - Producció i Consum Responsables">
          </router-link-locale>
        </div>
        <div class="sdg">
          <router-link-locale :to="{name: 'materials', params: {page: 1, sort: 'data desc, activitat_data_available desc'}, query: {material_ods: '13 - Acció per al Clima'}}" title="1. Fi de la pobresa">
            <img src="../assets/images/sdg/13.png" alt="13 - Acció per al Clima">
          </router-link-locale>
        </div>
        <div class="sdg">
          <router-link-locale :to="{name: 'materials', params: {page: 1, sort: 'data desc, activitat_data_available desc'}, query: {material_ods: '14 - Vida Submarina'}}" title="1. Fi de la pobresa">
            <img src="../assets/images/sdg/14.png" alt="14 - Vida Submarina">
          </router-link-locale>
        </div>
        <div class="sdg">
          <router-link-locale :to="{name: 'materials', params: {page: 1, sort: 'data desc, activitat_data_available desc'}, query: {material_ods: '15 - Vida d\'Ecosistemes Terrestres'}}" title="1. Fi de la pobresa">
            <img src="../assets/images/sdg/15.png" alt="15 - Vida d'Ecosistemes Terrestres">
          </router-link-locale>
        </div>
        <div class="sdg">
          <router-link-locale :to="{name: 'materials', params: {page: 1, sort: 'data desc, activitat_data_available desc'}, query: {material_ods: '16 - Pau, Justícia i Institucions Sòlides'}}" title="1. Fi de la pobresa">
            <img src="../assets/images/sdg/16.png" alt="16 - Pau, Justícia i Institucions Sòlides">
          </router-link-locale>
        </div>
        <div class="sdg">
          <router-link-locale :to="{name: 'materials', params: {page: 1, sort: 'data desc, activitat_data_available desc'}, query: {material_ods: '17 - Aliança per a Aconseguir els Objetius'}}" title="1. Fi de la pobresa">
            <img src="../assets/images/sdg/17.png" alt="17 - Aliança per a Aconseguir els Objetius">
          </router-link-locale>
        </div>
        <div class="sdg">
          <router-link-locale :to="{name: 'materials', params: {page: 1, sort: 'data desc, activitat_data_available desc'}, query: {material_ods: 'all'}}" title="1. Fi de la pobresa">
            <img src="../assets/images/sdg/all.png" alt="All">
          </router-link-locale>
        </div>

      </div>
    </div-->



    <h2 class="mt-5">{{ $t("Altres productes") }}</h2>

    <div class="row" style="outline-style: none;">

    <div class="col-xs-12 col-md-6 col-lg-3 mb-4">
      <div class="area-product h-100">
        <div class="card rounded-0 border-0 bg-transparent">
          <picture>
            <img loading="lazy" src="../assets/images/home/banner-upcommons.png" alt="UPCommons">
          </picture>
          <div class="card-body">
            <a href="https://upcommons.upc.edu" target="_blank" class="stretched-link">
              <h3 class="card-title">{{ $t("UPCommons") }}</h3>
              <p>{{ $t("Dipòsit institucional de la UPC") }}</p>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="col-xs-12 col-md-6 col-lg-3 mb-4">
      <div class="area-product h-100">
        <div class="card rounded-0 border-0 bg-transparent">
          <picture>
            <img loading="lazy" src="../assets/images/home/banner-geocommons.png" alt="GeoCommons">
          </picture>
          <div class="card-body">
            <a href="https://geocommons.upc.edu" target="_blank" class="stretched-link">
              <h3 class="card-title">{{ $t("GeoCommons") }}</h3>
              <p>{{ $t("Geolocalització de la producció academica de la UPC") }}</p>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="col-xs-12 col-md-6 col-lg-3 mb-4">
      <div class="area-product h-100">
        <div class="card rounded-0 border-0 bg-transparent">
          <picture>
            <img loading="lazy" src="../assets/images/home/banner-futur.png" alt="Futur">
          </picture>
          <div class="card-body">
            <a href="https://futur.upc.edu" target="_blank" class="stretched-link">
              <h3 class="card-title">Futur</h3>
              <p>{{ $t("Portal de la producció científica de la UPC") }}</p>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="col-xs-12 col-md-6 col-lg-3 mb-4">
      <div class="area-product h-100">
        <div class="card rounded-0 border-0 bg-transparent">
          <picture>
            <img loading="lazy" src="../assets/images/home/apren-publicar3.jpg" alt="Revistes UPC">
          </picture>
          <div class="card-body">
            <a href="https://www.upc.edu/beques" target="_blank" class="stretched-link">
              <h3 class="card-title">{{ $t("Revistes UPC") }}</h3>
              <p>{{ $t("Portal de revistes i actes de congressos UPC") }}</p>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="col-xs-12 col-md-6 col-lg-6 mb-4">
      <div class="area-product product-wide h-100">
        <div class="card rounded-0 border-0 bg-transparent">
          <picture>
            <img loading="lazy" src="../assets/images/home/banner-puntatenea.png" alt="Punt ATENEA">
          </picture>
          <div class="card-body">
            <a href="https://bibliotecnica.upc.edu/punt-atenea" target="_blank" class="stretched-link">
              <h3 class="card-title">{{ $t("Punt ATENEA") }}</h3>
              <p>{{ $t("Servei d'orientació i assessorament de cursos") }}</p>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="col-xs-12 col-md-6 col-lg-6 mb-4">
      <div class="area-product product-wide h-100">
        <div class="card rounded-0 border-0 bg-transparent">
          <picture>
            <img loading="lazy" src="../assets/images/home/banner-doiboard.png" alt="DOIBoard">
          </picture>
          <div class="card-body">
            <a href="https://doi.upc.edu" target="_blank" class="stretched-link">
              <h3 class="card-title">{{ $t("DOIBoard Crossref") }}</h3>
              <p>{{ $t("Información sobre DOIs y Prefijos CrossRef") }}</p>
            </a>
          </div>
        </div>
      </div>
    </div>


  </div>

  </div>

</template>

<script>

  import store from "@/store";
  import {useRoute} from "vue-router";
  import {onMounted, ref, computed} from "vue";
  import {useI18n} from "vue-i18n";
  import WeeklySummaryCard from "@/components/WeeklySummaryCard.vue";
  import HeaderService from "@/services/HeaderService";

  export default {
    name: "HomeView",
    components: {WeeklySummaryCard},

    setup() {
      const route = useRoute();
      const { locale } = useI18n();
      const dataHeader = ref({});
      const selectedImage = ref(null);
      const selectedColor = ref(null);

      const totalActivitats = computed(() => {
        if (!dataHeader.value.num_activitat || !dataHeader.value.num_material) return '0';
        const numActivitat = parseInt(dataHeader.value.num_activitat.toString().replace(/,/g, '')) || 0;
        const numMaterial = parseInt(dataHeader.value.num_material.toString().replace(/,/g, '')) || 0;
        return (numActivitat + numMaterial).toLocaleString();
      });

      const formatNumber = (value) => {
        if (!value) return '0';
        // Si ya es un string con formato, intentar parsearlo
        const numValue = typeof value === 'string' ? parseInt(value.replace(/,/g, '')) || 0 : value;
        return numValue.toLocaleString();
      };

      const extractDominantColor = (img) => {
        return new Promise((resolve) => {
          // Asegurarse de que la imagen esté cargada
          if (!img.complete || img.naturalWidth === 0) {
            img.onload = () => extractColor();
            img.onerror = () => resolve('#f2f5f6');
            return;
          }
          
          extractColor();
          
          function extractColor() {
            try {
              const canvas = document.createElement('canvas');
              const ctx = canvas.getContext('2d');
              
              canvas.width = img.naturalWidth || img.width || 100;
              canvas.height = img.naturalHeight || img.height || 100;
              
              ctx.drawImage(img, 0, 0);
              
              const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
              const data = imageData.data;
              
              // Tomamos el color del centro de la imagen
              const centerX = Math.floor(canvas.width / 2);
              const centerY = Math.floor(canvas.height / 2);
              const index = (centerY * canvas.width + centerX) * 4;
              
              const r = data[index];
              const g = data[index + 1];
              const b = data[index + 2];
              
              resolve(`rgb(${r}, ${g}, ${b})`);
            } catch (e) {
              // Si hay error, usar un color por defecto
              resolve('#f2f5f6');
            }
          }
        });
      };

      const handleImageClick = async (event, imageNumber) => {
        event.preventDefault();
        
        // Si se hace clic en la misma imagen, ocultar el div
        if (selectedImage.value === imageNumber) {
          selectedImage.value = null;
          selectedColor.value = null;
          return;
        }
        
        // Obtener el color dominante de la imagen
        let img = event.currentTarget.querySelector('img');
        if (!img || img.tagName !== 'IMG') {
          img = event.target.closest('img') || event.target;
        }
        
        if (img && img.tagName === 'IMG') {
          const color = await extractDominantColor(img);
          selectedImage.value = imageNumber;
          selectedColor.value = color;
        }
      };

      onMounted(async () => {
        await store.dispatch('updateSearchSelected', "Tots");
        await store.dispatch('updateBackgroundImage', { view: route.name, url: require('@/assets/images/sections/banner-blue.webp') });
        dataHeader.value = await HeaderService.getHeaderInfo();
      });

      return {
        locale,
        dataHeader,
        totalActivitats,
        formatNumber,
        selectedImage,
        selectedColor,
        handleImageClick
      }

    }


  }

</script>

<style scoped>
.image-container {
  overflow: hidden;
  position: relative;
  cursor: pointer;
}
.image-container img {
  transition: transform 0.3s ease;
  width: 100%;
  height: auto;
  object-fit: cover;
}

.image-selected-div {
  margin: 2rem auto;
  padding: 3rem;
  border-radius: 8px;
  text-align: center;
  max-width: 600px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  animation: fadeIn 0.3s ease-in;
}

.image-selected-div .selected-number {
  font-size: 6rem;
  font-weight: bold;
  color: white;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
  display: inline-block;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.image-container:hover img {
  transform: scale(1.05); /* Crecimiento mínimo */
  transition:all 0.25s ease-out;

}
a {
  text-decoration: none;
}

.no-after::after {
  content: none; /* Esto elimina el contenido del ::after */
}

.home-block-sdg {
  .sdg {
    width: calc(100% / 9);

    &:hover {
      opacity: 0.6;
    }
  }
}

.featured-background {
  background-color: #f2f5f6;
  margin-left: calc((100vw - 100%) / -2) !important;
  padding-left: calc((100vw - 100%) / 2);
  margin-right: calc((100vw - 100%) / -2) !important;
  padding-right: calc((100vw - 100%) / 2);
}


.well {
  padding: 18px;
  background-color: #F2F5F6;
  border: 0;
  border-radius: 4px;
  box-shadow: none;
  margin-bottom: 40px;
}

.list-numeral {
  margin:20px 0;
  column-count:5;
  -webkit-column-count:5;
  list-style:none;
  text-align:center;
  padding:0
}
@media (max-width: 768px) {
  .list-numeral {
    column-count:3;
  }
}
@media (max-width: 480px) {
  .list-numeral {
    column-count:2;
  }
}
.list-numeral li {
  -webkit-column-break-inside:avoid;
  page-break-inside:avoid;
  break-inside:avoid;
  font-size:1.5rem;
  display:block;
  line-height:1;
  padding-bottom:20px
}
.list-numeral strong {
  font-size:200%;
  display:block;
  font-weight:lighter
}
.list-numeral .violeta-fosc strong {
  color:#6734BA
}
.list-numeral .violeta-intens strong {
  color:#9D1CB2
}
.list-numeral .rosa-intens strong {
  color:#DA125F
}
.list-numeral .vermell-intens strong {
  color:#ED3F2C
}
.list-numeral .taronja-intens strong {
  color:#F75306
}
.list-numeral .groc-intens strong {
  color:#C97800
}
.area-product {
  transition: all 0.25s ease-out;
  transform: scale(1, 1) perspective(1px) translateZ(0px);
  background-color: #f2f5f6;
  border: none;
}

.area-product:hover {
  transform: perspective(25rem) scale(1.03);
}

.area-product picture img {
  width: 100%;
  aspect-ratio: 3/2;
  object-fit: cover;
  object-position: center center;
  height: auto;
}

.product-wide picture img {
  aspect-ratio: 3/1;
  object-position: center 15%; /* Middle ground between top and center */
}

</style>
